import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Draggable from 'react-draggable';
import { Row, Col, Label, FormGroup } from 'reactstrap';

import translations from 'services/translations/translations';
import AsyncSelect from 'react-select/async';
import TextInputField from '../forms/TextInputField';
import PrimaryButton from '../buttons/PrimaryButton';

import 'style/layout/Forms.css';
import 'style/layout/navbar/SaveNameModal.css';
import IProject from '../../interfaces/IProject';

const SaveProjectModal = ({
  setEditingProject,
  save,
  editingProject,
}: {
  setEditingProject: (project?: IProject) => void;
  save: (project: IProject) => void;
  editingProject?: IProject;
}): JSX.Element | null => {
  const { t } = useTranslation([translations.common]);
  const [project, setProject] = useState({} as IProject);

  const getDefaultProject = function (): IProject {
    return {
      created: '',
      createdUser: undefined,
      id: '',
      name: '',
      status: '',
      organizationUnitId: 0,
      squareMeters: 0,
      updated: '',
      updatedUser: undefined,
      wallTypes: '',
    };
  };

  const availableStatuses = [
    'test',
    'presentation',
    'model',
    'advance',
    'offer',
    'project',
    'revoked',
    'disposed',
  ];

  const defaultOptions = (): any[] => {
    return availableStatuses.map((s) => ({
      value: s,
      label: t(`${translations.common}:statusTypes:${s}`),
    }));
  };

  const getSelected = () => {
    return defaultOptions().filter((i) =>
      i.value.toLowerCase().includes(project.status?.toLowerCase())
    );
  };

  useEffect(() => {
    setProject(editingProject ?? getDefaultProject());
  }, [editingProject]);

  if (editingProject === undefined) {
    return null;
  }

  return (
    <Draggable>
      <div className="properties-edit-popup save-name-modal">
        <Row>
          <Col>
            <h2 onClick={() => setEditingProject(undefined)}>&times;</h2>
          </Col>
        </Row>
        <Row>
          <Col>
            <TextInputField
              id="name"
              label={t(`${translations.common}:Name`)}
              onChange={(e: any) => {
                if (e) {
                  setProject({
                    ...project,
                    name: e.target.value,
                  });
                }
              }}
              value={project.name}
              name="name"
              required
              className="edit-fields"
            />
            <FormGroup>
              <Label className="label">
                {t(`${translations.common}:Status`)}
              </Label>
              <AsyncSelect
                className="text-field search-field"
                isClearable
                name="status"
                defaultOptions={defaultOptions()}
                value={getSelected()}
                onChange={(e: any) => {
                  if (e) {
                    setProject({
                      ...project,
                      status: e.value,
                    });
                  }
                }}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col>
            <PrimaryButton
              onClick={() => {
                save(project);
              }}
              className="button-edit-popup"
            >
              {t(`${translations.common}:Save`).toLocaleUpperCase()}
            </PrimaryButton>
          </Col>
        </Row>
      </div>
    </Draggable>
  );
};

export default SaveProjectModal;
